/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import withAuthGuard from '../withAuthGuard';
import withLoader from '../../components/withLoader';
import withPaymentStatus from '../withPaymentStatus';
import OrderSideComponent from '../OrderSideComponent';
import MethodSelectionPage from '../../components/MethodSelectionPage';
import withMembershipGuard from '../../containers/withMembershipGuard';
import withNoMembershipPurchased from '../../containers/withNoMembershipPurchased';

import { selectClient, selectLocation, selectSearchObj } from '../../global-selectors';
import { pickPromoSlugFromSearchObj } from '../../utils';
import { getSubPaymentMethods } from '../../queries/payment';
import { selectUserData } from '../../queries/selectors/user';
import { withSidecardWrapper } from '../../components/withSidecardWrapper';
import { getProductsToBuy, getSelectedPlan, selectShoppingCartConfig } from '../../queries/selectors/shoppingCart';
import { deleteCouponCode, requestAsync } from '../../queries/actions';
import {
  selectCouponApply,
  selectSingleSubscriptionClient,
  selectSubscriberConfig
} from '../../queries/selectors/bootstrap';
import { setCurrentSubPaymentMethod } from '../../queries/actions/payment';
import { selectPaymentMethods, selectCurrentPaymentMethod, selectSubPaymentConfig } from '../../queries/selectors/payment';
import { selectHasPaymentMethods, selectSubscriberPaymentMethods, selectCountryCode } from '../../queries/selectors/subscriptions';
import { selectActivePlanSubscription, selectProducts } from '../../queries/selectors/products';
import { connectRequest } from '../../utils/query';
import { ApplyCouponCodeRequest } from '../../queries/coupons';
import withAutoCaptcha from '../withAutoCaptcha';


const mapStateToProps = (state, props) => {
  const couponApply = selectCouponApply(state);
  const userData = selectUserData(state);
  const planSelected = getSelectedPlan(state);
  const couponCode = planSelected?.couponApply?.code;

  return {
    productsToBuy: getProductsToBuy(state),
    subscriber: selectSubscriberConfig(state),
    couponApply,
    userData,
    countryCode: selectCountryCode(state),
    location: selectLocation(state),
    paymentMethods: selectSubscriberPaymentMethods(state),
    subscriberHasPaymentMethods: selectHasPaymentMethods(state),
    subPaymentMethods: selectSubPaymentConfig(state),
    methods: selectPaymentMethods(state),
    currentPaymentMethod: selectCurrentPaymentMethod(state),
    currentSubscription: selectActivePlanSubscription(state),    isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
    planSelected,
    client: selectClient(state),
    shoppingCart: selectShoppingCartConfig(state),
    products: selectProducts(state),
    token: userData?.token,
    ...(couponCode && { code: couponCode }),
    promoSlug: pickPromoSlugFromSearchObj(selectSearchObj(state)),
  }
};

const mapPropsToConfig = (props) => {
  if (props?.code) {
   
    if (!props.isCaptchaEnabled) {
      return [ApplyCouponCodeRequest(props)];
    } else if (props.captchaToken) {
      return [ApplyCouponCodeRequest({
        ...props,
        captchaToken: props.captchaToken
      })];
    }
  }
  return [];
}


const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    getSubPaymentMethods: payload => requestAsync(getSubPaymentMethods, payload),
    setCurrentSubPaymentMethod: payload => dispatch(setCurrentSubPaymentMethod(payload)),
    deleteCouponCode: payload => dispatch(deleteCouponCode(payload))
  }, dispatch)
);

export default compose(
  injectIntl,
  withPaymentStatus,
  withNoMembershipPurchased,
  withMembershipGuard,
  connect(mapStateToProps, mapDispatchToProps),
  withAutoCaptcha,
  connectRequest(mapPropsToConfig),
  withAuthGuard({ toLoginURL: true }),
  withLoader(({ methods }) => methods && !methods.length),
  withSidecardWrapper({
    SideComponent: OrderSideComponent,
    texts: {
      title: <FormattedMessage id="PaymentMethodSelector.methods.dlocal.title" />
    }
  })
)(MethodSelectionPage);
